<div class="iframe-container">
  <iframe src="https://thehotelmate.com/Hotel-Yogiraj?BookingEngine=true" frameborder="0" allowfullscreen></iframe>
</div>